import { SelectModel } from "../models/treeModel";

export const formatCPFCNPJ = (value: string) => {
  var formattedValue: string;
  formattedValue = "";
  if (value) {
    if (value.length <= 11) {
      formattedValue = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
    } else {
      formattedValue = value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "$1.$2.$3/$4-$5");
    }
  }

  return formattedValue;
};

export const formatTelefone = (value: string) => {
  var formattedValue: string;
  formattedValue = "";
  var formattedValue = value?.replace(/\D/g, "");
  formattedValue = formattedValue?.replace(/^0/, "");
  if (value) {
    if (formattedValue.length > 10) {
      formattedValue = formattedValue?.replace(/^(\d\d)(\d{5})(\d{4}).*/, "($1) $2-$3");
    } else if (formattedValue.length > 5) {
      formattedValue = formattedValue?.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, "($1) $2-$3");
    } else if (formattedValue.length > 2) {
      formattedValue = formattedValue?.replace(/^(\d\d)(\d{0,5})/, "($1) $2");
    } else {
      formattedValue = formattedValue?.replace(/^(\d*)/, "($1");
    }
  }
  return formattedValue;
};

export const formatPorcentagem = (value: number) => {
  var formattedValue: string;
  formattedValue = "";
  value = value * 100;
  formattedValue = value.toString() + "%";
  return formattedValue;
};

export const newFormatPorcentagem = (value: number, decimalPlaces: number = 1) => {
  let formattedValue: string = "";
  value = value * 100;
  formattedValue = parseFloat(value.toFixed(decimalPlaces)).toString().replace(".", ",") + "%";
  return formattedValue;
};

export const formatPorcentagemContaRecorrente = (value: number) => {
  var formattedValue: string;
  formattedValue = "";
  formattedValue = value.toString().replace("%", "") + "%";
  return formattedValue;
};

export const generateTree = (value: SelectModel[] = []) => {
  var retorno: any[] = [];
  value.map(({ children, ...props }: any) => {
    if (children.length === 0) {
      children = undefined;
    }
    retorno.push({
      value: props.id,
      title: props.title,
      disabled: props.sinteticoAnalitico.toLowerCase() === "s" || children !== undefined || !props.ativo,
      children: generateTree(children),
    });
  });
  return retorno;
};
